import { Table } from "@tanstack/react-table";
import { TableHeaderData } from "../components/core/DataTable/types";
import { download, generateCsv, mkConfig } from "export-to-csv";

export const exportTanstackTableToCSV = <TData>(
  csvName: string,
  headers?: TableHeaderData[],
  table?: Table<TData>
) => {
  const csvConfig = mkConfig({
    fieldSeparator: ",",
    filename: csvName, // export file name (without .csv)
    decimalSeparator: ".",
    columnHeaders: headers?.map((header) => ({
      key: header.key,
      displayLabel: header.label
    }))
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rowData: any = table?.getCoreRowModel().rows.map((row) => row.original);
  const csv = generateCsv(csvConfig)(rowData);

  download(csvConfig)(csv);
};
